<template>
  <div v-if="visible" class="ai-component">
    <!-- Header -->
    <div class="component-header">
      <h3 class="component-title">AI Assistant</h3>
      <button class="close-button" @click="handleClose">
        <i class="el-icon-close"></i>
      </button>
    </div>

    <!-- Content -->
    <div class="component-content">
      <div class="component-container">
        <div>
          <p>Current Task: {{ taskType }}</p>
          <!-- Model Selection -->
          <div class="model-selection">
            <el-select v-model="currentMode" size="medium">
              <el-option
                v-for="item in modelList"
                :key="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
        </div>

          <!-- Chat History Section -->
          <div class="chat-history" ref="chatHistory">
            <div
              v-for="(message, index) in chatHistory"
              :key="index"
              :class="['message', message.role]"
            >
              <div class="message-content" v-if="message.role === 'assistant' || (message.role === 'user' && message.content !== '')">
                <div class="message-header">
                  {{ message.role === "user" ? "You" : "AI" }}
                </div>
                <div>
                  <!-- Show loading dots for empty assistant messages while generating -->
                  <div v-if="message.role === 'assistant' && message.content === '' && isGenerate">
                    <span>Waiting for AI response{{ loadingDots }}</span>
                  </div>
                  <div v-else v-html="changeToHtml(message.content)"></div>

                  <!-- Add action buttons for AI responses -->
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'chat'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="copyAssistantContent(message.content)"
                    >
                      Copy
                    </el-button>
                    <el-button
                      size="mini"
                      type="success"
                      @click="overwriteContent(message.content)"
                    >
                      Overwrite
                    </el-button>
                  </div>
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'collectionDescriptionPolish'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.content)"
                    >
                      Apply this description
                    </el-button>
                  </div>
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'bundleDescriptionGeneration'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.content)"
                    >
                      Apply this description
                    </el-button>
                  </div>
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'createCollectionStructure'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.structure)"
                    >
                      Apply this structure to my collection
                    </el-button>
                  </div>
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'groupKnowitsSuggestion'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.structure)"
                    >
                      Apply these knowits to my group
                    </el-button>
                  </div>
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'createPostContent'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.structure)"
                    >
                      Apply these contents to my post
                    </el-button>
                  </div>
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'createSinglePostContent'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.structure)"
                    >
                      Apply this content to my post
                    </el-button>
                  </div>
                  <div
                    v-if="
                      message.role === 'assistant' &&
                      !isGenerate &&
                      message.type === 'improveSinglePostContent'
                    "
                    class="assistant-actions"
                  >
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.structure, 'update')"
                    >
                      Update this content to my post
                    </el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="takeAIResult(message.structure, 'insert')"
                    >
                      Insert this content after
                    </el-button>
                  </div>
                </div>
                <div>
                  <div
                    class="messageItem1"
                    v-if="message.type === 'createCollectionCoverPrompt'"
                  >
                    <img style="max-width: 100%" :src="message.imgUrl" />
                    <div class="imageEditBtn" v-if="message.taskId && message.action !== 'UPSCALE'">
                      
                      <el-button
                        size="small"
                        @click="toEditImage('UPSCALE', 1, message.taskId)"
                        >U1</el-button
                      >
                      <el-button
                        size="small"
                        @click="toEditImage('UPSCALE', 2, message.taskId)"
                        >U2</el-button
                      >
                      <el-button
                        size="small"
                        @click="toEditImage('UPSCALE', 3, message.taskId)"
                        >U3</el-button
                      >
                      <el-button
                        size="small"
                        @click="toEditImage('UPSCALE', 4, message.taskId)"
                        >U4</el-button
                      >
                      <el-button
                        size="small"
                        @click="toEditImage('REROLL', null, message.taskId)"
                      >
                        <i class="el-icon-refresh"></i>
                      </el-button>
                    </div>
                    <div class="imageEditBtn" v-if="message.taskId && message.action !== 'UPSCALE'">
                      <el-button
                        size="small"
                        @click="toEditImage('VARIATION', 1, message.taskId)"
                        >V1</el-button
                      >
                      <el-button
                        size="small"
                        @click="toEditImage('VARIATION', 2, message.taskId)"
                        >V2</el-button
                      >
                      <el-button
                        size="small"
                        @click="toEditImage('VARIATION', 3, message.taskId)"
                        >V3</el-button
                      >
                      <el-button
                        size="small"
                        @click="toEditImage('VARIATION', 4, message.taskId)"
                        >V4</el-button
                      >
                    </div>
                    <div class="messageItem1" v-if="message.taskId && message.action === 'UPSCALE'">
                      <el-button
                        size="small"
                        type="primary"
                        @click="useImageAsCover(message.imgUrl)"
                      >
                        Use this image as cover
                      </el-button>
                    </div>
                  </div>
                  <div
                    v-if="message.type === 'createCollectionCover' && !message.imgUrl"
                    class="messageItem1"
                  >
                    Current progress in image generation {{ progress }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Input Section - Fixed at bottom -->
          <div class="input-section">
            <el-input
              v-model="userInput"
              type="textarea"
              :rows="4"
              placeholder="Type your message here..."
              :disabled="loading"
              @keydown.native="handleKeyDown"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { postRequest, postRequestAISG } from "../apis/front";
import DOMPurify from "dompurify";

export default {
  name: "AIDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    task: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "AI Assistant",
    },
    initialInput: {
      type: String,
      default: "",
    },
    taskType: {
      type: String,
      default: "chat",
    },
    contextString: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      progress: "0%",
      loadingDots: ".",
      loadingInterval: null,
      AImethod: {
        "Collection Description Polish": "collectionDescriptionPolish",
        "Collection Structure Generation": "createCollectionStructure",
        "Generate Post Contents": "createPostRawContent",
        "Generate Single Post Content": "createSinglePostContent",
        "Improve Single Post Content": "improveSinglePostContent",
        "Generate on Custom Material": "createPostContent",
        "Collection Cover Generation": "createCollectionCoverPrompt",
        "Group Knowits Suggestion": "groupKnowitsSuggestion",
        "Bundle Description Generation": "bundleDescriptionGeneration",
      },
      userInput: "",
      chatHistory: [],
      loading: false,
      modelList: [
        "gpt-4",
        "gpt-4o",
        "gpt-4o-mini",
        "gpt-4-turbo",
        "gpt-3.5",
        "moonshot-v1-8k",
        "moonshot-v1-32k",
        "moonshot-v1-128k",
        "o1-preview",
        "o1-mini",
        "claude-3-5-sonnet-20240620",
        "claude-3-opus-20240229",
        "claude-3-sonnet-20240229",
        "claude-3-haiku-20240307",
        "deepseek-chat",
        "deepseek-reasoner",
        "siliconflow/Pro/deepseek-ai/DeepSeek-R1",
        "siliconflow/Pro/deepseek-ai/DeepSeek-V3",
        "midjourney",
        "leonardo-ai",
      ],
      currentMode: "gpt-4",
      isGenerate: false,
      contentForAIEdit: "",
      aiResult: [],
      latestResult: [],
      mj_prompt: "",
    };
  },
  computed: {
    // Removed dialogVisible computed property as it's no longer needed
  },
  watch: {
    visible(newVal) {
      console.log("AIDialog visible prop changed:", newVal);
      if (newVal) {
        this.userInput = this.initialInput;
        this.taskType = this.taskType;
        this.currentMode = 'gpt-4';//set default model to gpt-4
        this.chatHistory = [];
        console.log("taskType: ", this.taskType);
        switch (this.taskType) {
          case "chat":
            // Default chat behavior - no special initialization needed
            break;
          case "Generate Single Post Content":
            if (!this.chatHistory.length) {
              this.chatHistory.push({
                role: "assistant",
                content:
                  "What do you want me to add to this post? Please kindly provide some instructions",
                type: "chat",
              });
            }
            this.scrollToBottom();
            break;
          case "Improve Single Post Content":
            if (!this.chatHistory.length) {
              this.chatHistory.push({
                role: "assistant",
                content:
                  "What do you want me to improve in this post? Please kindly provide some instructions",
                type: "chat",
              });
            }
            this.scrollToBottom();
            break;
          case "Collection Description Polish":
            if (!this.chatHistory.length) {
              this.sendAIMessage();
            }
            this.scrollToBottom();
            break;
          case "Bundle Description Generation":
            if (!this.chatHistory.length) {
              this.sendAIMessage();
            }
            this.scrollToBottom();
            break;
          case "Generate on Custom Material":
            if (!this.chatHistory.length) {
              this.chatHistory.push({
                role: "assistant",
                content:
                  "What custom material do you want me to use to generate the post?",
                type: "chat",
              });
            }
            this.scrollToBottom();
            break;
          case "Collection Cover Generation":
            // this.currentMode = "midjourney";
            // if (!this.chatHistory.length) {
            //   this.sendAIMessage();
            // }
            // this.scrollToBottom();

            console.log(this.taskType);
            if (this.contextString) {
              const params = JSON.parse(this.contextString);
              
              this.callBackendAIMethod(params, this.AImethod[this.taskType]);
            }

            break;
          case "Group Knowits Suggestion":
            console.log(this.taskType);
            if (this.contextString) {
              this.sendAIMessage();
            }
            this.scrollToBottom();
            break;
          case "Collection Structure Generation":
            if (!this.chatHistory.length) {
              this.chatHistory.push({
                role: "assistant",
                content:
                  "Before generation, do you have any specific instructions for the collection structure?",
                type: "chat",
              });
            }
            this.scrollToBottom();
            break;
          default:
            console.log(this.taskType);
            if (this.contextString) {
              const params = JSON.parse(this.contextString);
              this.callBackendAIMethod(params, this.AImethod[this.taskType]);
            }
            break;
        }
      }
    },
    taskType(newVal) {
      // Removed empty watch handler
    },
  },
  mounted() {
    console.log("AIDialog mounted");
    // Configure marked with highlight.js
  },
  methods: {
    animateLoadingDots(load_message=null) {
      console.log("animateLoadingDots 1");
      this.loadingInterval = setInterval(() => {
        console.log("animateLoadingDots 2");
        this.loadingDots = this.loadingDots.length >= 3 ? "." : this.loadingDots + ".";
        // Update the loading message in chat history
        const lastMessage = this.chatHistory[this.chatHistory.length - 1];

        console.log("animateLoadingDots 3");
        if (lastMessage && lastMessage.type === "loading") {
          console.log("animateLoadingDots 4");
          this.$set(lastMessage, "content", load_message ? load_message + "" + this.loadingDots : this.loadingDots);
        }
      }, 500);
    },

    async handleGenerate() {
      if (!this.userInput.trim()) return;
      console.log(this.taskType);
      this.loading = true;
      if (this.taskType === "chat") {
        await this.sendAIMessage();
      }else if(this.taskType === "Collection Structure Generation"){
        
        if (this.contextString) {
          

          const params = JSON.parse(this.contextString);
          params.user_instruction = this.userInput;
          this.chatHistory.push({
            role: "user",
            content: this.userInput,
            type: "chat",
          });
          this.userInput = "";
          this.callBackendAIMethod(params, this.AImethod[this.taskType]);
        }
      } else {
        this.sendAIMessage();
        // Handle other task types
        await this.handleCustomTaskGenerate();
      }
      this.loading = false;
    },

    async handleCustomTaskGenerate() {
      // Custom task type handling logic goes here
      // This method can be overridden or customized based on specific task requirements
    },

    async sendAIMessage() {
      let promptContext = "";

      var packagedContent = this.userInput;
      if (this.taskType === "Generate Single Post Content") {
        promptContext =
          '[Do not use Markdown triple backticks ```json to denote the results] MUST Return a JSON array with NO extra words. Compile and Provide content for one single atomized card or multiple cards (depends on user instructions) which is/are to be added to the existing cards of provided post theme. Each card should contains concise texts that constitute relatively a centered idea or statement. The short texts can either be 1) ONE key sentence, or 2) a few concise sentences (no more than 5) or 3) a number of short paragraphs, which can vary between 10 to 300 words. The texts shoudl include HTML formats and use sub-titles and highlights where appropriate. The added card(s) should well complement the existing contents of the post and connects coherently on the logic level. The returned card content structure should follow this: "[{"content_type":"text","content":"HTML-formattedContent text for card 1"}" for TEXT card, "{"content_type":"quiz","quiz_content":{"question":"Question text for the quiz","options":["optionA","optionB","optionC","optionD"],"correct_answer":"A/B/C/D","explanation":"Answer explanation text"}}]" for QUIZ card (The quiz options should not include any ABCD denoter at the beginning of the options).';
        packagedContent =
          "Standard Prompt Instruction: " +
          promptContext +
          "\n" +
          "User Extra Customer Instruction: " +
          this.userInput +
          "\n" +
          "The content context  is: " +
          this.contextString;
        console.log("Packaged Content: ", packagedContent);
      } else if (this.taskType === "Improve Single Post Content") {
        promptContext =
          '[Do not use Markdown triple backticks ```json to denote the results] MUST Return a JSON array with NO extra words. Improve the provided post content from one single atomized card based on the user\'s instructions. Each card should contains concise texts that constitute relatively a centered idea or statement. The short texts can either be 1) ONE key sentence, or 2) a few concise sentences (no more than 5) or 3) a number of short paragraphs, which can vary between 10 to 300 words. The texts shoudl include HTML formats and use sub-titles and highlights where appropriate. After improvement,The card should still well complement the existing contents of the post and connects coherently on the logic level. The returned card content structure should follow this: "[{"content_type":"text","content":"HTML-formattedContent text for card 1"}]" for TEXT card, "[{"content_type":"quiz","quiz_content":{"question":"Question text for the quiz","options":["optionA","optionB","optionC","optionD"],"correct_answer":"A/B/C/D","explanation":"Answer explanation text"}}]" for QUIZ card (The quiz options should NOT include any ABCD denoter at the beginning of the options).';
        packagedContent =
          "Standard Prompt Instruction: " +
          promptContext +
          "\n" +
          "User Extra Customer Instruction: " +
          this.userInput +
          "\n" +
          "The content context  is: " +
          this.contextString;
        console.log("Packaged Content: ", packagedContent);
      } else if (this.taskType === "Group Knowits Suggestion") {
        promptContext = '[Do not use Markdown triple backticks ```json to denote the results] '+
        'MUST Return a JSON array with NO extra words. '+
        'Provide a suggested list of sub topic for the group theme (group title) '+
        'based on the larger context provided below.'+
        'The suggested list should include 4-7 sub topics. Please return the list in data format like this: [{"knowit_id":"","post_info":{"title":"the title string here for knowit 1"}},{"knowit_id":"","post_info":{"title":"the title string here for knowit 2"}}]'+
        'DO not put any leading or denoter texts before the JSON data string. Return the JSON data string ONly and directly';
        packagedContent =
          "Standard Prompt Instruction: " +
          promptContext +
          "\n" +
         "The content context  is: " +
          this.contextString;
        console.log("Packaged Content: ", packagedContent);
      } else if (this.taskType === "Collection Description Polish") {
        promptContext =
          "Write a new description (if no description yet) or polish the current description based on user instructions (if any).Directly return plain text of the description with no extra words. Do not repeat or include the title as the subject of the description. Use pronouns instead.";
        packagedContent =
          "Standard Prompt Instruction: " +
          promptContext +
          "\n" +
          "User Extra Customer Instruction: " +
          this.userInput +
          "\n" +
          "The content context  is: " +
          this.contextString;
        console.log("Packaged Content: ", packagedContent);
      } else if (this.taskType === "Bundle Description Generation") {
        promptContext =
          "Write a new description (if no description yet) or polish the current description based on user instructions (if any).Directly return plain text of the description with no extra words. Do not repeat or include the title as the subject of the description. Use pronouns instead.";
        packagedContent =
          "Standard Prompt Instruction: " +
          promptContext +
          "\n" +
          "User Extra Customer Instruction: " +
          this.userInput +
          "\n" +
          "The content context  is: " +
          this.contextString;
        console.log("Packaged Content: ", packagedContent);
      } else if (this.taskType === "Generate on Custom Material") {
        promptContext =
          '[Do not use Markdown triple backticks ```json to denote the results] Compile and Provide content for an array of atomized cards around designated post theme and based on the custom material provided. Each card should contains concise texts that constitute relatively a centered idea or statement. The short texts can either be 1) ONE key sentence, or 2) a few concise sentences (no more than 5) or 3) a number of short paragraphs, which can vary between 10 to 300 words. The texts shoudl include HTML formats and use sub-titles and highlights where appropriate. The array should overall include dozens of cards to comprehensively covers and explains the theme topic. Every few cards, insert one quiz card content. The returned array structure should follow this: "[{"content_type":"text","content":"HTML-formamted content text for card 1"},{"content_type":"text","content":"HTML-formamted content text for card 2"},{"content_type":"quiz","quiz_content":{"question":"Question text for the quiz","options":["optionA","optionB","optionC","optionD"],"correct_answer":"A/B/C/D  (NOT the option text string!)","explanation":"Answer explanation text"}}]. (The quiz options should NOT include any ABCD denoter at the beginning of the options. The correct_answer should be denoter A/B/C/D directly but does NOT repeat option string inself)".DO NOT insert any extra texts or denoters before or after the data string itself. JUST return the data texts only and directly.';
        packagedContent =
          "Standard Prompt Instruction: " +
          promptContext +
          "\n" +
          "User Provided Custom Material: " +
          this.userInput;
        console.log("Packaged Content: ", packagedContent);
      } else if (this.taskType === "Collection Cover Generation") {
        const artStylePrompt = '';
        // let contextStringObj = JSON.parse(this.contextString);
        // packagedContent = `Create a book cover that represents this collection theme: ${contextStringObj.collection_name}.Key theme elements from description: ${contextStringObj.collection_description} . Art Style: ${artStylePrompt} `;
        // packagedContent = `${artStylePrompt} A modern abstract representation of leadership and growth, featuring interweaving geometric shapes suggesting upward movement and connection. Central focal point shows an elegant abstract composition of ascending lines and circles, symbolizing progress and guidance. Dynamic composition with flowing forms in rich deep blues, vibrant purples, and confident gold accents. Incorporate subtle sacred geometry patterns suggesting interconnected networks and organizational structure. Minimal design aesthetic with clean lines and bold shapes, emphasizing professional sophistication. Background features gentle gradient transitions from deep to light tones, creating depth and dimension. Include abstract elements suggesting a compass or guiding star motif, rendered in a contemporary style. Professional graphic design approach with editorial finesse, perfect for educational material. --stylize 750 --v 5.2 --q 2 --no text --ar 5:7 --chaos 20 --style raw`;
        
        packagedContent = this.mj_prompt.replace(/^"|"$/g, '') + "The prompt text should NOT appear on the image The prompt text should NOT appear on the image The prompt text should NOT appear on the image. --no text fonts letters watermark words typography slogans signature --ar 5:7 ";
        console.log("Packaged Content: ", packagedContent);
      }

      let userMessage = {
        role: "user",
        content: packagedContent,
      };

      let userMessageSimple = {
        role: "user",
        content: this.userInput,
      };

      let messages = [...this.chatHistory, userMessage];
      this.chatHistory.push(userMessageSimple);
      this.chatHistory.push({
        role: "assistant",
        content: "",
        type: this.taskType ? this.AImethod[this.taskType] : "chat",
      });

      console.log(
        "Last Message:" + this.chatHistory[this.chatHistory.length - 1]
      );

      this.userInput = "";
      this.isGenerate = true;
      this.animateLoadingDots("Waiting for AI response");

      const that = this;
      if (this.currentMode === "midjourney") {
        let result = await this.exeMidJModel(packagedContent);
        if (result) {
          let obj = this.chatHistory[this.chatHistory.length - 1];
          this.$set(obj, "imgUrl", result.url);
          this.$set(obj, "taskId", result.taskId);
          this.$set(obj, "action", result.action);
        }
      } else {
        try {
          await fetchEventSource(
            "https://web-backend-sg.reachable-edu.com/AIChat/Test.php",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              openWhenHidden: true,
              body: JSON.stringify({
                model: that.currentMode,
                messages,
              }),
              onopen(response) {
                console.log("Connection established", response);
              },
              onmessage(event) {
                if (that.currentMode.indexOf("claude") != -1 && event.data) {
                  const result = JSON.parse(event.data);
                  if (result.type === "message_delta") {
                    that.isGenerate = false;
                    clearInterval(that.loadingInterval);
                    return;
                  }
                } else if (event.data === "Connection closed") {
                  that.isGenerate = false;
                  clearInterval(that.loadingInterval);
                  return;
                }

                const result = JSON.parse(event.data);
                if (that.currentMode.indexOf("claude") != -1) {
                  if (result.type === "content_block_delta") {
                    that.chatHistory[that.chatHistory.length - 1].content +=
                      result.delta.text;
                  }
                } else if (result.time && result.content) {
                  that.chatHistory[that.chatHistory.length - 1].content +=
                    result.content;
                }

                that.$nextTick(() => {
                  that.scrollToBottom();
                });
              },
              onclose() {
                that.isGenerate = false;
                clearInterval(that.loadingInterval);

                const lastMessage =
                  that.chatHistory[that.chatHistory.length - 1];
                if (lastMessage && lastMessage.type !== "chat") {
                  try {
                    // Remove extra quotes if present and parse
                    let contentToParse = lastMessage.content;
                    if (
                      contentToParse.startsWith('"') &&
                      contentToParse.endsWith('"')
                    ) {
                      contentToParse = contentToParse.slice(1, -1);
                    }
                    // Store original content as structure
                    lastMessage.structure = JSON.parse(contentToParse);
                    

                    // Parse structure and convert to HTML
                    const structure = lastMessage.structure;
                    let htmlContent = "";

                    if (
                      that.taskType === "Generate Single Post Content" ||
                      that.taskType === "Improve Single Post Content" ||
                      that.taskType === "Generate on Custom Material"
                    ) {
                      // Handle single post content generation
                      // Check if structure is an array, if not wrap it in an array
                      const items = Array.isArray(structure)
                        ? structure
                        : [structure];

                      console.log("items: ", items);

                      items.forEach((item) => {
                        // Default to text type if content_type is not text or quiz
                        if (!item.content_type || (item.content_type !== "text" && item.content_type !== "quiz")) {
                          item.content_type = "text";
                          
                        }
                        
                        if (item.content_type === "text") {
                          htmlContent += `<div class="text-content">${item.content}</div>`;
                        } else if (item.content_type === "quiz") {
                          htmlContent += `
                          <div class="quiz-content">
                            <div class="question">${
                              item.quiz_content.question
                            }</div>
                            <div class="options">
                              ${item.quiz_content.options
                                .map(
                                  (option, index) =>
                                    `<div class="option">${
                                      ["A", "B", "C", "D"][index]
                                    }. ${option}</div>`
                                )
                                .join("")}
                            </div>
                            <div class="answer">Correct Answer: ${
                              item.quiz_content.correct_answer
                            }</div>
                            <div class="explanation">${
                              item.quiz_content.explanation
                            }</div>
                          </div>
                        `;
                        }
                      });

                    }else if(that.taskType === "Group Knowits Suggestion"){
                      // Handle group knowits suggestion
                      const suggestions = structure;
                      htmlContent = '<div class="suggestions-list">';
                      
                      // Add header
                      htmlContent += `<div class="suggestions-header">Suggested Knowits:</div>`;
                      
                      // Add each suggestion as a list item
                      suggestions.forEach((suggestion, index) => {
                        htmlContent += `
                          <div class="suggestion-item">
                            
                            <div class="suggestion-content">
                              <div class="suggestion-title">${index + 1}. ${suggestion.post_info.title}</div>
                              
                            </div>
                          </div>
                        `;
                      });

                      htmlContent += '</div>';
                    } else {
                      // Handle other structure types
                      // Check if structure is an array, if not wrap it in an array
                      htmlContent = lastMessage.content;
                    }

                    that.chatHistory[that.chatHistory.length - 1].content =
                      htmlContent || lastMessage.structure;
                  } catch (e) {
                    console.warn("Failed to parse structure:", e);
                    // Keep original content if parsing fails
                  }
                }
              },
              onerror() {
                that.isGenerate = false;
                clearInterval(that.loadingInterval);
              },
            }
          );
        } catch (error) {
          this.$message.error("Failed to generate AI response");
          this.isGenerate = false;
          clearInterval(this.loadingInterval);
        }
      }
    },
    async toEditImage(action, index, taskId) {
      let result = await this.exeMidJModelChange(action, index, taskId);
      if (result) {
        let obj = this.chatHistory[this.chatHistory.length - 1];
        obj.imgUrl = result.url;
        obj.taskId = result.taskId;
        obj.action = result.action;
      }
    },
    exeMidJModelChange(action, index, taskId) {
      return new Promise((resolve) => {
        this.loading = true;
        postRequestAISG("changeImage", {
          action,
          index,
          taskId,
        }).then(async (res) => {
          this.loading = false;
          let result = res.data.data;
          if (result.code === 1) {
            this.progress = "0%";
            this.chatHistory.push({
              role: "assistant",
              content: "",
              type: this.taskType ? this.AImethod[this.taskType] : "chat",
              imgUrl: "",
              taskId: "",
            });
            this.scrollToBottom();
            let messageId = res.data.data.result;
            let url = await this.getResult(messageId);
            if (url) {
              resolve({
                taskId: messageId,
                url: url.url,
                action: url.action
              });
            }
          } else {
            this.$message.error(result.description);
            resolve(false);
          }
        });
      });
    },
    exeMidJModel(prompt) {
      return new Promise((resolve) => {
        this.loading = true;
        postRequestAISG("getMidJourneyNew", {
          prompt,
        }).then(async (res) => {
          this.loading = false;
          this.progress = "0%";
          let messageId = res.data.data.result;
          let url = await this.getResult(messageId);
          if (url) {
            resolve({
              taskId: messageId,
              url: url.url,
              action: url.action
            });
            console.log("action debug: ", url.action);
          }
        });
      });
    },
    getResult(messageId) {
      let flag = false;
      return new Promise((resolve) => {
        let timer = setInterval(() => {
          if (!flag) {
            flag = true;
            postRequestAISG("getMidJourneyResultNew", {
              taskId: messageId,
            }).then((res) => {
              if (res.data.code === 0) {
                flag = false;
                let result = res.data.data;
                // Update the progress in the chat history
                const lastMessage = this.chatHistory[this.chatHistory.length - 1];
                if (lastMessage && lastMessage.type === "createCollectionCoverPrompt") {
                  this.$set(lastMessage, "content", `Current progress in image generation: ${result.progress}`);
                }
                if (result.status === "SUCCESS") {
                  clearInterval(timer);
                  resolve({
                    url: result.image_qiniu_url,
                    action: result.action
                  });
                }
              } else {
                clearInterval(timer);
                resolve();
              }
            });
          }
        }, 3000);
      });
    },
    handleUse() {
      const lastAiMessage = [...this.chatHistory]
        .reverse()
        .find((msg) => msg.role === "assistant");

      if (lastAiMessage) {
        this.$emit("use", lastAiMessage.content);
        this.handleClose();
      }
    },

    handleClose() {
      if (this.loading) return;
      this.chatHistory = [];
      this.userInput = "";
      this.$emit("update:visible", false);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatHistory = this.$refs.chatHistory;
        if (chatHistory) {
          chatHistory.scrollTop = chatHistory.scrollHeight;
        }
      });
    },
    changeToHtml(data) {
      return DOMPurify.sanitize(data);
    },

    copyAssistantContent(content) {
      navigator.clipboard.writeText(content);
      this.$message.success("Content copied to clipboard");
    },
    overwriteContent(content) {
      this.$emit("use", content);
      this.handleClose();
    },
    handleKeyDown(e) {
      if ((e.ctrlKey || e.shiftKey) && e.key === "Enter") {
        e.preventDefault();
        console.log("handleGenerate");
        this.handleGenerate();
      }
    },

    callBackendAIMethod(params, method) {
      // Add loading indicator to chat history
      console.log("callBackendAIMethod 1");
      this.chatHistory.push({
        role: "assistant", 
        content: ".",
        type: "loading"
      });
      this.scrollToBottom();
      console.log("method: ", method);
      if(method === "createCollectionCoverPrompt")
        this.animateLoadingDots("Generating a description of the cover image");
      else
        this.animateLoadingDots();

      console.log("callBackendAIMethod 2");
      return postRequest(method, params).then((response) => {
        console.log("callBackendAIMethod 3");
        clearInterval(this.loadingInterval); // Stop the animation
        if (response.data.status === "success" && response.data.code === 0) {

          console.log("callBackendAIMethod 4");

          if(method === "createCollectionCoverPrompt"){
            console.log("callBackendAIMethod 5");
            this.mj_prompt = response.data.data;
            this.currentMode = "midjourney";
            console.log("callBackendAIMethod 6");
            // if (!this.chatHistory.length) {
              console.log("callBackendAIMethod 7");
              this.sendAIMessage();//这里是发送信息
            // }
            this.scrollToBottom();

          }else if(method === "createPostRawContent"){
            const raw_materials = response.data.data;

            if(raw_materials.length > 0){
              params.post_material = raw_materials;
              this.callBackendAIMethod(params, "createPostContent");
            }else{
              this.$message.error("No raw materials generated");
            }
          }else{
            // Remove the loading message if it's the last item
            if (this.chatHistory.length > 0 && this.chatHistory[this.chatHistory.length - 1].type === 'loading') {
              this.chatHistory.pop();
            }
            this.chatHistory.push({
              role: "assistant",
              content: response.data.data.html,
              structure: response.data.data.structure,
              type: method,
            });
            this.scrollToBottom();
          }
          
        }
      }).catch(() => {
        clearInterval(this.loadingInterval); // Stop the animation on error
      });
    },

    takeAIResult(result, type = null) {
      this.$emit("use", result, type);
      this.handleClose();
    },

    useImageAsCover(imageUrl) {
      this.$emit('use', imageUrl);
      this.handleClose();
    },
  },
};
</script>

<style scoped>
.ai-dialog-content {
  height: calc(100vh - 300px);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.model-selection {
  margin-bottom: 10px;
}

.chat-history {
  height: 400px; /* Fixed height */
  flex: none; /* Remove flex: 1 to prevent stretching */
  overflow-y: auto;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 0;
}

.message {
  margin-bottom: 12px;
  max-width: 85%;
}

.message.assistant {
  margin-left: 0;
  margin-right: auto;
}

.message.user {
  margin-left: auto;
  margin-right: 0;
}

.message-content {
  padding: 12px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.message.user .message-content {
  background: #409eff;
  color: white;
}

.message-header {
  font-size: 0.8em;
  margin-bottom: 4px;
  opacity: 0.7;
}

.input-section {
  padding: 10px 0; /* Adjusted padding */
  background-color: transparent; /* Remove background color */
}

.assistant-actions {
  margin-top: 10px;
  display: flex;
  gap: 5px;
}

/* Normal component styles - no dialog behavior */
.ai-component {
  background: white;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.component-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  background: #fafafa;
  flex-shrink: 0;
}

.component-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.close-button {
  background: none;
  border: none;
  font-size: 18px;
  color: #909399;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-button:hover {
  background-color: #f5f7fa;
  color: #606266;
}

.component-content {
  flex: 1;
  overflow: hidden;
  padding: 0;
}

.message-content :deep(pre) {
  background-color: #f4f4f4;
  padding: 1em;
  border-radius: 4px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 500px;
  overflow-y: auto;
}

.message-content :deep(code) {
  font-family: "Courier New", Courier, monospace;
  font-size: 0.9em;
  line-height: 1.4;
  tab-size: 2;
}

/* For JSON specifically */
.message-content :deep(.language-json) {
  color: #333;
}

.message-content :deep(.language-json .punctuation) {
  color: #666;
}

.message.user .message-content :deep(pre) {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

pre {
  width: 100%;
  padding: 10px;
  background-color: #23241f;
  border-radius: 6px;
  color: #f8f8f2;
  box-sizing: border-box;
  overflow-x: auto;
}
pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em;
}
code.hljs {
  padding: 3px 5px;
}
.hljs {
  background: #23241f;
  color: #f8f8f2;
}
.hljs-subst,
.hljs-tag {
  color: #f8f8f2;
}
.hljs-emphasis,
.hljs-strong {
  color: #a8a8a2;
}
.hljs-bullet,
.hljs-link,
.hljs-literal,
.hljs-number,
.hljs-quote,
.hljs-regexp {
  color: #ae81ff;
}
.hljs-code,
.hljs-section,
.hljs-selector-class,
.hljs-title {
  color: #a6e22e;
}
.hljs-strong {
  font-weight: 700;
}
.hljs-emphasis {
  font-style: italic;
}
.hljs-attr,
.hljs-keyword,
.hljs-name,
.hljs-selector-tag {
  color: #f92672;
}
.hljs-attribute,
.hljs-symbol {
  color: #66d9ef;
}
.hljs-class .hljs-title,
.hljs-params,
.hljs-title.class_ {
  color: #f8f8f2;
}
.hljs-addition,
.hljs-built_in,
.hljs-selector-attr,
.hljs-selector-id,
.hljs-selector-pseudo,
.hljs-string,
.hljs-template-variable,
.hljs-type,
.hljs-variable {
  color: #e6db74;
}
.hljs-comment,
.hljs-deletion,
.hljs-meta {
  color: #75715e;
}

.component-container {
  display: flex;
  flex-direction: column;
  height: 500px; /* Fixed height for inline component */
  padding: 20px;
}

.chat-history {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 10px;
}

.input-section {
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 10px 0;
  border-top: 1px solid #eee;
}

/* Loading dots animation */
.loading-dots {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-size: 14px;
}

.dots {
  display: flex;
  gap: 4px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #409eff;
  animation: loading-dots 1.4s infinite ease-in-out;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes loading-dots {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Responsive styles for inline component */
@media (max-width: 768px) {
  .component-container {
    height: 400px;
    padding: 16px;
  }
  
  .component-header {
    padding: 12px 16px;
  }
  
  .chat-history {
    padding: 8px;
  }
}
</style> 